export default __webpack_public_path__ + "static/media/mail-sent.b9bb60d0.gif";